/**
 * Ödül Öneri tesis (lokasyon) sabitleri.
 * Başvurudaki applicant.location ile hizalı (Pazaryeri / Çayırova).
 */
export const ODUL_FACILITIES = ['Pazaryeri', 'Çayırova']

/** Bölüm/yönetici kayıtlarında facility yoksa (eski veriler) bu tesis kabul edilir */
export const DEFAULT_DEPARTMENT_FACILITY = 'Pazaryeri'

export const ODUL_FACILITY_FILTER_ALL = 'all'

/**
 * Serbest metin lokasyonu kanonik tesis adına çevirir.
 * @returns {string} 'Pazaryeri' | 'Çayırova' | '' | orijinal trim
 */
export const normalizeFacility = (value) => {
  const raw = String(value || '').trim()
  if (!raw) return ''

  const lower = raw.toLocaleLowerCase('tr-TR')
  if (lower.includes('pazar')) return 'Pazaryeri'
  if (lower.includes('çayır') || lower.includes('cayir')) return 'Çayırova'

  const exact = ODUL_FACILITIES.find(
    (facility) => facility.toLocaleLowerCase('tr-TR') === lower
  )
  return exact || raw
}

/** Departman facility alanını kanonikleştirir; boşsa Pazaryeri */
export const resolveDepartmentFacility = (value) => {
  const normalized = normalizeFacility(value)
  return ODUL_FACILITIES.includes(normalized) ? normalized : DEFAULT_DEPARTMENT_FACILITY
}

export const getRecordFacility = (record) =>
  normalizeFacility(record?.applicant?.location || record?.facility || '')

export const recordMatchesFacility = (record, facilityFilter) => {
  if (!facilityFilter || facilityFilter === ODUL_FACILITY_FILTER_ALL) return true
  return getRecordFacility(record) === facilityFilter
}

/** Kurul üyesi facilities alanını kanonikleştirir (geçersizler atılır) */
export const normalizeMemberFacilities = (facilities) => {
  if (!Array.isArray(facilities)) return []
  return facilities
    .map(normalizeFacility)
    .filter((facility) => ODUL_FACILITIES.includes(facility))
}

/**
 * Kurul üyesi tesis kısıtı.
 * facilities yok/boş → kısıt yok (her iki tesis — normal üyeler).
 * Dolu ise yalnızca listedeki tesisler (fabrika müdürleri).
 */
export const memberMatchesRecordFacility = (member, facility) => {
  const allowed = normalizeMemberFacilities(member?.facilities)
  if (allowed.length === 0) return true
  const recordFacility = normalizeFacility(facility)
  if (!recordFacility) return true
  return allowed.includes(recordFacility)
}
